<div class="col-12 form-container edit-profile">
  <form [formGroup]='editProfileForm'>

    <div class="grid">

      <div class="col-3">
        <div class="profile-image-wrapper">
          <img class="profile-image" [src]="profileUrl"
            onerror="src='/assets/images/temp/default_profile.png'" />
          <div class="profile-image-overlay" (click)="openImagePreviewDialog()">
            <i class="fa fa-eye"></i>
          </div>
        </div>
        <div class='display-image profile-btn pt-2'>
          <app-file-uploader class="p-fileupload-new" (fileUpload)="onUploadProfileImage($event)" accept="image/*"
            [uploadButtonLabel]="chooseLabel"></app-file-uploader>
          <div class="max-limit-doc pt-2">( Maximum upload file size: 18 MB )</div>
        </div>
      </div>

      <div class="col-9">
        <div class="grid">
        <div class="form-field col-12 md:col-6 lg:col-6 sm:col-6">
          <div class="form-label">
            <label for="firstName" translate>f_name</label>
            <label class="asterisk">*</label>
          </div>
          <div class="form-control">
            <input formControlName="firstName" type="text" pInputText />
          </div>
          <div class="form-errors"
            *ngIf="editProfileForm.controls.firstName.errors  && (editProfileForm.controls.firstName.dirty || editProfileForm.controls.firstName.touched)">
            <div [hidden]="!editProfileForm.controls.firstName.errors.required" translate>
              first_name_reqd
            </div>
            <div [hidden]="!editProfileForm.controls.firstName.errors.minlength" translate>
              min_length
            </div>
            <div [hidden]="!editProfileForm.controls.firstName.errors.maxlength" translate>
              max_length
            </div>
            <div [hidden]="!editProfileForm.controls.firstName.errors.pattern" translate>
              name_pattern
            </div>
          </div>
        </div>

        <div class="form-field col-12 md:col-6 lg:col-6">
          <div class="form-label">
            <label for="lastName" translate>l_name</label>
            <label class="asterisk">*</label>
          </div>
          <div class="form-control">
            <input formControlName="lastName" type="text" pInputText />
          </div>
          <div class="form-errors"
            *ngIf="editProfileForm.controls.lastName.errors  && (editProfileForm.controls.lastName.dirty || editProfileForm.controls.lastName.touched)">
            <div [hidden]="!editProfileForm.controls.lastName.errors.required" translate>
              last_name_reqd
            </div>
            <div [hidden]="!editProfileForm.controls.lastName.errors.minlength" translate>
              min_length
            </div>
            <div [hidden]="!editProfileForm.controls.lastName.errors.maxlength" translate>
              max_length
            </div>
            <div [hidden]="!editProfileForm.controls.lastName.errors.pattern" translate>
              name_pattern
            </div>
          </div>
        </div>

        <div class="form-field col-12 md:col-12 lg:col-12 py-0">
          <div class="form-label">
            <label for="email" translate>label_email</label>
            <label class="asterisk">*</label>
          </div>
          <div class="form-control">
            <input formControlName="email" type="text" pInputText />
          </div>
          <div class="form-errors"
            *ngIf="editProfileForm.controls.email.errors  && (editProfileForm.controls.email.dirty || editProfileForm.controls.email.touched)">
            <div [hidden]="!editProfileForm.controls.email.errors.required" translate>
              error_email_id_required
            </div>
            <div [hidden]="!editProfileForm.controls.email.errors.pattern" translate>
              email_pattern
            </div>
          </div>
        </div>

        <div class="form-field col-5 md:col-5 lg:col-5">
          <div class="form-label">
            <label for="phone" translate>label_country_code</label>
            <label class="asterisk">*</label>
          </div>
          <div class="form-control">
            <p-select [options]="countryCodeList" formControlName="phoneCode" [filter]="true"> </p-select>
          </div>
          <div class="form-errors"
            *ngIf="editProfileForm.controls.phoneCode.errors  && (editProfileForm.controls.phoneCode.dirty || editProfileForm.controls.phoneCode.touched)">
            <div [hidden]="!editProfileForm.controls.phoneCode.errors.required" translate>
              country_code_required
            </div>
          </div>
        </div>

        <div class="form-field col-6 md:col-7 lg:col-7">
          <div class="form-label">
            <label for="phone" translate>phone</label>
            <label class="asterisk">*</label>
          </div>
          <div class="form-control">
            <input formControlName="phone" type="text" pInputText />
          </div>
          <div class="form-errors"
            *ngIf="editProfileForm.controls.phone.errors  && (editProfileForm.controls.phone.dirty || editProfileForm.controls.phone.touched)">
            <div [hidden]="!editProfileForm.controls.phone.errors.required" translate>
              contact_number_require
            </div>
            <div [hidden]="!editProfileForm.controls.phone.errors.pattern" translate>
              error_invalid_phone_number
            </div>
            <div [hidden]="!editProfileForm.controls.phone.errors.minlength" translate>
              error_invalid_phone_number_min_max
            </div>
            <div [hidden]="!editProfileForm.controls.phone.errors.maxlength" translate>
              error_invalid_phone_number_min_max
            </div>
          </div>
        </div>

        <div class="col-12 py-0">
          <span (click)="redirectToAppReleaseHistory()" id="app-release-link" class="app-release-link" translate>
            lbl_app_release_history</span>
        </div>

        <div class="form-buttons col-12 col-nopad">
          <button pButton type="button" label="Save" icon="fa fa-check" [disabled]="!editProfileForm.valid"
            (click)="updateProfile($event)"></button>
          <button class="negative-button" pButton type="button" icon="fa fa-close" label="Cancel"
            (click)="closeEditProfile($event)"></button>
        </div>
      </div>
    </div>
    </div>
  </form>
</div>

<p-dialog modal="true" position="center" [style]="{'width': '450px'}" [(visible)]="imagePreviewVisible">
  <ng-template pTemplate="header" class="header-weight">
    <label translate>label_preview_image</label>
  </ng-template>
  <div class="col-12" style="text-align: center;">
    <img [src]="profileUrl" style="max-width:100%; max-height:350px;"
      onerror="src='/assets/images/temp/default_profile.png'" />
  </div>
  <div class="form-buttons col-12 col-nopad" style="margin-top: 1rem;">
    <button pButton type="button" icon="fa fa-download" label="Download" (click)="downloadProfileImage()"></button>
  </div>
</p-dialog>

<p-toast key="message"></p-toast>